var NO_DATA = "admin.reporting.error.empty";
var SERVER_ERROR = "errors.PBDEAInternalServerError";
export default function (err) {
    var _a, _b, _c, _d;
    var httpStatus = (_d = (_c = (_b = (_a = err === null || err === void 0 ? void 0 : err.networkError) === null || _a === void 0 ? void 0 : _a.apiError) === null || _b === void 0 ? void 0 : _b.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.httpStatus;
    switch (httpStatus) {
        case 404:
            return NO_DATA;
        case 500:
            return SERVER_ERROR;
        default:
            return NO_DATA;
    }
}
